<template>
  <div class="page-layout" v-loading="ifLoading" element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0)">
    <div style="height: 100%; width: 100%; overflow: hidden;">
      <div class="breadcrumb" v-if="breadcrumbs.length > 0">
        <div class="one" v-if="breadcrumbs.length === 1">
          {{ breadcrumbs[0].title }}
        </div>
        <div class="more" v-else>
          <el-button class="zwx-button zwx-button-24" style="margin-top: 10px; margin-left: 14px;" @click="back">返回
          </el-button>
          <el-breadcrumb class="zwx-breadcrumb" separator="/">
            <el-breadcrumb-item v-for="item in breadcrumbs" :key="item.name">{{ item.title }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <zwx-scrollbar-y ref="zwxScrollbarY" class="page-layout-scrollbar-y" @scrollTop="scrollbarYScrollTop">
        <div class="content">
          <keep-alive :include="keepAlive">
            <router-view @loading="loading" @breadcrumb="breadcrumb" :routerScrollTop="scrollTop"
                         :routerScrollHeight="scrollHeight"/>
          </keep-alive>
        </div>
      </zwx-scrollbar-y>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageLayout',
  data() {
    return {
      users: this.$store.state.users,
      scrollbarYVue: [],
      scrollbarYList: [],
      ifLoading: false,
      scrollTop: 0,
      scrollHeight: 0,
    }
  },
  watch: {
    '$route.name'(newValue, oldValue) {
      const index = this.scrollbarYVue.indexOf(newValue)
      if (index === -1) {
        this.scrollbarYVue.push(oldValue)
        this.scrollbarYList.push(this.$refs.zwxScrollbarY.getTop())
        this.$refs.zwxScrollbarY.scrollTop(0)
      } else {
        this.$refs.zwxScrollbarY.scrollTop(this.scrollbarYList[index])
        this.scrollbarYVue.splice(index, this.scrollbarYVue.length - index)
        this.scrollbarYList.splice(index, this.scrollbarYList.length - index)
      }
    },
    breadcrumbs() {
      this.$nextTick(() => this.breadcrumbBindClick())
    },
    routerLoading(routerLoading) {
      this.ifLoading = routerLoading
    },
  },
  computed: {
    keepAlive() {
      return this.$store.state.keepAlive
    },
    breadcrumbs() {
      return this.$store.state.breadcrumbs
    },
    routerLoading() {
      return this.$store.state.routerLoading
    },
  },
  mounted() {
    const self = this
    window.onbeforeunload = function () {
      self.$destroy()
    }
    this.$zwxBases.listenDocumentWH(document.getElementsByClassName('zwx-router-scrollbar-y')[0], this.scrollHeightCallback)
  },
  methods: {
    breadcrumbBindClick() {
      const breadcrumbList = document.getElementsByClassName('zwx-breadcrumb')
      if (breadcrumbList === undefined || msBreadcrumbList === null || msBreadcrumbList.length === 0) return
      const elBreadcrumbInner = breadcrumbList[0].getElementsByClassName('el-breadcrumb__inner')
      for (let i = 0, length = elBreadcrumbInner.length; i < length; i++) {
        elBreadcrumbInner[i].onclick = () => this.jump(i)
      }
    },
    loading(ifLoading) {
      this.ifLoading = ifLoading
    },
    breadcrumb(title, cover) {
      const length = this.breadcrumbs.length
      if (length === 0) return
      if (cover) this.breadcrumbs[length - 1].title = title
      else this.breadcrumbs[length - 1].title = this.breadcrumbs[length - 1].title + '（' + title + '）'
    },
    back() {
      this.$router.replace({name: this.breadcrumbs[this.breadcrumbs.length - 2].name})
    },
    jump(index) {
      if (index === this.breadcrumbs.length - 1) {
        return
      }
      this.$router.replace({name: this.breadcrumbs[index].name})
    },
    scrollbarYScrollTop(top) {
      this.scrollTop = top
    },
    scrollHeightCallback(width, height) {
      this.scrollHeight = height
    },
  },
}
</script>

<style lang="less" scoped>
.page-layout {
  height: 100%;
  display: flex;
  flex-direction: column;

  .breadcrumb {
    flex-basis: 34px;
    flex-shrink: 0;
    border-bottom: 1px solid #cdcdcd;
  }

  .breadcrumb .one {
    display: inline-block;
    font-size: 14px;
    color: #1f2d3d;
    height: 42px;
    line-height: 42px;
    margin-left: 12px;
    font-family: "Harmony Medium";
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .breadcrumb .more {
    display: flex;
    height: 42px;
    line-height: 42px;
    color: #194dff !important;
  }

  .page-layout-scrollbar-y {
    height: calc(100% - 43px) !important;
  }

  .content {
    position: relative;
  }

  .content > div {
    position: relative;
    height: 100%;
  }
}
</style>
